import { twMerge } from "tailwind-merge";
import { Card, Flex, Text } from "../../components";
import { useAppStore, useCartStore } from "../../stores";
import { TotalsInput } from "../../utils/totals";
import { OrderType } from "../../types/enums";
import { Tools } from "../../utils";
import { CardProps } from "antd";

const Footer = ({
  totals,
  className,
  classNames,
  ...props
}: CardProps & { totals?: TotalsInput }) => {
  const cart = useCartStore();
  const orderType = useAppStore((state) => state.location?.orderType);
  const source = totals ?? { ...cart, orderType };
  const lines = [
    { label: "Subtotal", price: source.subtotal },
    source.orderType !== OrderType.pickup && {
      label: "Delivery Charges",
      price: source.deliveryCharges ?? 0,
    },
    !!source.discount && {
      label:
        source.discountBreakdown?.applied === "promo"
          ? `Promo (${source.discountBreakdown?.promoCode || ""})`
          : "Discount",
      price: -Number(source.discount || 0),
    },
    !!source.tax && {
      label: source.pricesIncludeTax
        ? `Tax incl. (${source.taxPercent || 0}%)`
        : `Tax (${source.taxPercent || 0}%)`,
      price: source.tax,
      muted: !!source.pricesIncludeTax,
    },
    { label: "Grand total", price: source.grandtotal },
  ].filter((line): line is { label: string; price: number; muted?: boolean } => !!line);

  return (
    <Card
      {...props}
      className={twMerge("w-100", className)}
      classNames={{ ...classNames, body: twMerge("p-12", classNames?.body) }}
    >
      <Flex vertical gap="1rem">
        {lines.map((line, index) => {
          const last = index === lines.length - 1;
          const text = {
            level: last ? 4 : ("text" as const),
            weight: last ? 700 : "normal",
            type: line.muted ? ("secondary" as const) : undefined,
          };
          return (
            <Flex key={line.label}>
              <Text {...text} children={line.label} className="d-flex flex-1" />
              <Text
                {...text}
                className="d-flex justify-flex-end"
                children={Tools.toCurrency(line.price)}
              />
            </Flex>
          );
        })}
      </Flex>
    </Card>
  );
};

export default Footer;
